import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specialization4',
  templateUrl: './specialization4.component.html',
  styleUrls: ['./specialization4.component.css']
})
export class Specialization4Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
